import React from 'react';
import PropTypes from 'prop-types';

const FeeGroupModalErrorWrapper = (props) => {

  return (
    <section className="alert alert-danger">
      <p>
        <b>There were errors processing this form.</b> Please review the issues marked below.
      </p>
      <ul>
        {props.children}
      </ul>
    </section>
  )
}

FeeGroupModalErrorWrapper.propTypes = {
  children: PropTypes.node
};

export default FeeGroupModalErrorWrapper;